// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../elements/Modal/Modal';
import { FormattedMessage } from 'react-intl';
import Loading from '../../../../../elements/Loading/Loading';

import buttonStyle from '../../../../../assets/styles/button.scss';
import style from './DeleteModal.scss';
import classNames from 'classnames/bind';

type Props = {
  +deleteOrder: (orderId: string) => void;
  +handleClose: () => void;
  +modalVisible?: boolean;
  +isDeleting?: boolean;
  +orderId?: string;
};

export default class DeleteModal extends Component<Props> {

  render() {
    const { handleClose, deleteOrder, modalVisible, isDeleting, orderId } = this.props;
    return (
      <Modal handleClose={() => !isDeleting && handleClose()}
             width={544}
             height={616}
             open={modalVisible}>
        {isDeleting && <Loading type="sk-three-bounce"
                                color="lightBlue"
                                className={style.modalLoading}
                                number={3}/>}
        {!isDeleting &&
        <section className={style.deleteOrderModal}>
          <FormattedMessage id="order.purchase.modal.delete.title">{
            text => <h2 className={style.title}>{text}</h2>
          }</FormattedMessage>
          <FormattedMessage id="order.purchase.modal.delete.text">{
            txt => <p>{txt}</p>
          }</FormattedMessage>
          <FormattedMessage id="order.purchase.modal.delete.button.delete">{
            txt => <button className={classNames(buttonStyle.btn, buttonStyle.red, style.btn)}
                           onClick={() => orderId && deleteOrder(orderId)}>{txt}</button>
          }</FormattedMessage>
          <FormattedMessage id="order.purchase.modal.delete.button.close">{
            txt => <button className={classNames(buttonStyle.btn, buttonStyle.darkGrey, style.btn)}
                           onClick={() => handleClose()}>{txt}</button>
          }</FormattedMessage>
        </section>}

      </Modal>);
  }
}

DeleteModal.propTypes = {
  deleteOrder: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  modalVisible: PropTypes.bool,
  isDeleting: PropTypes.bool,
  orderId: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/components/DeleteModal/DeleteModal.jsx